import { useMutation } from "@tanstack/react-query";
import { saveDotdigitalConfigs } from "../../api/bDotdigitalApi";

export const useSaveDotdigitalConfigs = () => {
  return useMutation({
    mutationKey: ["save-dotdigital-configs"],
    mutationFn: (data) => saveDotdigitalConfigs(data),
    onError: (error) => {
      console.error("Dotdigital config save error:", error.response || error);
    },
  });
};